//import React from 'react';
const PAGE = [
  {
    //NUM 0
    "content": "Inscribirse"
  },
  {
    //NUM 1
    "content": "Inscribirse"
  }
];




  
export default PAGE;